function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgImage = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["image", "style", "width", "height", "testID", "isNested"],
  _excluded2 = ["width", "height"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var SvgImage = exports.SvgImage = (0, _react.memo)(function (_ref) {
  var image = _ref.image,
    style = _ref.style,
    width = _ref.width,
    height = _ref.height,
    _ref$testID = _ref.testID,
    testID = _ref$testID === void 0 ? 'SvgImage' : _ref$testID,
    _ref$isNested = _ref.isNested,
    isNested = _ref$isNested === void 0 ? false : _ref$isNested,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _ref2 = _reactNative.StyleSheet.flatten(style) || {},
    imageWidth = _ref2.width,
    imageHeight = _ref2.height,
    imageStyles = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var _width = imageWidth || width;
  var _height = imageHeight || height;
  var styles = [{
    width: _width || '100%',
    height: _height || '100%'
  }, imageStyles];
  if (image != null && image["default"]) {
    return (0, _jsxRuntime.jsx)(image["default"], Object.assign({
      style: styles,
      width: _width,
      height: _height,
      testID: testID
    }, props));
  }
  if (typeof image === 'string') {
    if (isNested) {
      return (0, _jsxRuntime.jsx)("image", {
        href: image,
        width: _width,
        height: _height,
        "data-testid": testID
      });
    }
    return (0, _jsxRuntime.jsx)(_reactNative.ImageBackground, Object.assign({
      source: {
        uri: image
      },
      resizeMode: "contain",
      style: styles,
      imageStyle: {
        width: '100%',
        height: '100%'
      },
      testID: testID
    }, props));
  }
  return null;
});